function toggle($, selector, deselector, items) {
  var $selector = $(selector);
  var $deselector = $(deselector);
  var $items = $(items);

  $selector.click(function() {
    $items.each(function(_, elem) {
      $(elem).prop('checked', true);
    });

    $selector.hide();
    $deselector.show();
  });

  $deselector.click(function() {
    $items.each(function(_, elem) {
      $(elem).prop('checked', false);
    });

    $deselector.hide();
    $selector.show();
  });
}

function toggleBudget($) {
  toggle($, '.js-budget-select', '.js-budget-deselect', '.js-budget-items input');
}

function toggleCategory($) {
  toggle($, '.js-category-select', '.js-category-deselect', '.js-category-items input');
}

function togglePrefecture($) {
  toggle($, '.js-pref-select', '.js-pref-deselect', '.js-pref-items input');
}

/**
 * Runner script.
 */
function run($) {
  toggleBudget($);
  toggleCategory($);
  togglePrefecture($);
}

module.exports = {
  run: run
};
